import { AdvancePeriodTimezone } from '@data/interfaces/interfaces';
import { ScudRoles } from 'constants/roles';
import { Dayjs } from 'dayjs';

export const USER_STORAGE = 'USER_STORAGE';

export interface UserHttp {
  type: 'users';
  id: string;
  attributes: {
    id: string;
    avatar: string;
    email: string;
    first_name: string;
    online: boolean;
    hierarchy: number;
    initials: string;
    last_connection: string | null;
    last_name: string;
    emulate_by: string;
    other_role: number | null;
    position: number;
    roles: ScudRoles[];
    permissions: string[];
    scopes: string[];
    service: string;
    title: string;
    manager_repository_id: string;
    code_analytique_paie: string;
    libelle_analytique_paie: string;
    bu_principale: string;
    expires_at: string | null;
    regions?: AdvancePeriodTimezone[];
    groups: { analytic_code: string; analytic_label: string }[];
  };
}

export interface User {
  id: string;
  avatar: string;
  email: string;
  fullname: string;
  firstname: string;
  lastname: string;
  emulateBy: string;
  online: boolean;
  hierarchy: number;
  initials: string;
  lastConnection: Dayjs | null;
  otherRole: number | null;
  roles: ScudRoles[];
  permissions: string[];
  scopes: string[];
  service: string;
  title: string;
  managerId: string;
  isAuthenticated: boolean;
  payrollAnalyticCode: string;
  analyticalLabel: string;
  principalBu: string;
  expiresAt: Dayjs | null;
  regions: AdvancePeriodTimezone[];
  groups: { analytic_code: string; analytic_label: string }[];
}

export interface UserWizard {
  type: 'user_repositories';
  id: string;
  attributes: {
    avatar: string;
    email: string;
    first_name: string;
    hierarchy: number;
    initials: string;
    last_name: string;
    other_role: number | null;
    role: number;
    service: string;
    title: string;
  };
}

export interface LogoutHttp {
  type: 'logout';
  attributes: {
    success: boolean;
  };
}
